import type { FC } from "react"
import { useConfigModel } from "@/models"
import { LockOutlined } from "@ant-design/icons"
import { useCreation } from "ahooks-v2"
import classNames from "classnames"
import { Link, useParams } from "react-router-dom"
import type { RouterIdsVO } from "@/api"
import { headerTabs } from "@/constants/constant"
import { getMenuKeyByPath, getCurrentPageType, getPathByMenuKey } from "@/util/commonUtils"
import { getAllParentIds } from "@/util/util"
import "./index.scss"
// ==============================================
interface PageTabsProps {
  left?: number
}
const PageTabs: FC<PageTabsProps> = ({ left = 400 }) => {
  const { currentConfig, industryCategory } = useConfigModel()
  const path = getCurrentPageType()
  const menuKey = getMenuKeyByPath(path)
  const param = useParams<RouterIdsVO>() as any

  // 菜单
  const Tabs = useCreation(() => {
    const modules = currentConfig?.modules
    if (!currentConfig || !modules) return null
    const { sandTableId, brandId, cityId } = param
    const ids = getAllParentIds(modules, menuKey, "moduleType")
    const menuKeys = headerTabs.map((item) => item.value)

    return modules.slice().map((tab) => {
      const { moduleName, moduleType, unlocked, children } = tab
      const subKeys = children?.filter((v) => v.unlocked)?.map((v) => v.moduleType) || []
      const subModuleType = subKeys?.[0] || ""
      const tabName = moduleName === "网点分析" ? `${industryCategory}分析` : moduleName
      const currentPath = getPathByMenuKey(
        menuKeys.includes(moduleType) ? moduleType : subModuleType,
      )
      const tabPath = `/${sandTableId}/${brandId}/${cityId}/${currentPath}`

      if (unlocked)
        return (
          <div className={classNames("tab", ids.includes(moduleType) && "active")} key={moduleType}>
            <Link to={tabPath}>{tabName}</Link>
          </div>
        )

      if (currentConfig.visible)
        return (
          <div className="tab" key={tabName}>
            <span className="lock">
              {tabName}&nbsp;
              <LockOutlined />
            </span>
          </div>
        )

      return null
    })
  }, [currentConfig, industryCategory, param, menuKey])

  return (
    <div
      className="cm-tab pangmen first-order-menus"
      style={{
        left: `${left}px`,
      }}
    >
      {Tabs}
    </div>
  )
}

export default PageTabs
